import { Stack, Typography } from "@mui/material";

import {
    Shared_FormTemplate_QuestionTypeDropdownFragment,
    Shared_FormTemplate_QuestionTypeSelectFragment,
} from "../fragments/fragmentsTypes.generated";
import { NarrowedFormField } from "../types";

type Props = {
    field: NarrowedFormField<
        Shared_FormTemplate_QuestionTypeSelectFragment | Shared_FormTemplate_QuestionTypeDropdownFragment
    >;
    value: string | null | undefined;
};

export default function SelectableQuestionDisplay({ field, value }: Props) {
    const displayValue = value ? (field.type.options.find(opt => opt.key === value)?.name ?? value) : null;

    return (
        <Stack>
            <Typography variant="caption" color="text.secondary">
                {field.name}
            </Typography>
            <Typography>{displayValue || "—"}</Typography>
        </Stack>
    );
}
